import React, { Component } from 'react';
import { LoadProduction } from '../../store/MetaStore';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes, uploadBytesResumable } from 'firebase/storage'
import db, { storage } from '../../firebase';
import { FaCirclePlus } from 'react-icons/fa6'
import { Modal, Button, FormControl, InputGroup, Card, CardBody, CardTitle, Carousel, Row, Col, FormSelect, Form } from 'react-bootstrap';

export default class FrameLandingpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...LoadProduction.init,
      contentMap: [],
      contentList: [],
      modalCreateItem: false,
      pointSelectedType: '',
      newContent: {},
      pointSelectedContentId: null,
      isFooterVisible: false,
      idItem: '',
    }
  }

  cleanPathname() {
    const { pathname } = window.location;
    const decodedPathname = decodeURIComponent(pathname);
    return decodedPathname.startsWith('/admin/')
      ? decodedPathname.substring('/admin/'.length)
      : decodedPathname;
  }

  async componentDidMount() {
    const { pathname } = window.location;
    const cleanedPathname = this.cleanPathname()
    const license = await doc(db, '$:__sites-name', cleanedPathname)
    this.setState({ nameSite: cleanedPathname })
    if (cleanedPathname !== '') {
      const isLicenseAvalible = await getDoc(license)
      this.state = isLicenseAvalible.data()
      isLicenseAvalible.exists() ?
        this.setState({
          ...isLicenseAvalible.data(),
          pageExist: true
        }, () => { })
        :
        setTimeout(() => {
          alert('este sitio no existe'); window.location = '/'
        }, 1500);
    }
  }

  async handleUpdateCong() {
    try {
      this.setState({
        modalAlert: true,
        txtMainAlert: 'Configuracion emparejada con el servidor',
        txtTitleAlert: 'Mi sistemita',
        alertState: 'success',
      }, async () => {
        this.setState({
          modalAlert: false,
          menuToActive: 'none'
        })
        await updateDoc(doc(db, '$:__sites-name', this.state.siteName), this.state)
      })
    } catch (e) {
      this.setState({
        modalAlert: true,
        txtMainAlert: 'Error al emparejar con el servidor',
        txtTitleAlert: 'Mi sistemita',
        alertState: 'danger',
      })
    }
  }

  handleCreateContainer = () => {
    this.setState({ modalCreateItem: true, pointSelectedType: '', newContent: {} });
  };

  createSCID() {
    const seedTok = '0123456789';
    const seedKey = 'abcdefg01234567DABT';

    let makeToken = '';
    let makeKey = '';

    for (let i = 0; i < 6; i++) {
      makeToken += seedTok[Math.floor(Math.random() * seedTok.length)];
    }

    for (let i = 0; i < 10; i++) {
      makeKey += seedKey[Math.floor(Math.random() * seedKey.length)];
    }

    return { makeKey };
  }

  crossBtnItemStore() {
    let putImg = document.querySelectorAll('#itemImg')
    putImg[0].click()
  }

  generateNewSSCID = () => {
    const newSSCID = this.createSCID().makeKey;
    this.setState({ sscid: newSSCID });
  }

  async getUrlTitle() {
    const { newContent = {}, pointImgTarget, pointSelectedType } = this.state;

    const loadResources = () => {
      try {
        getDownloadURL(ref(storage, 'items/Thumbs/' + this.state.siteName + '/imgpage /' + this.state.sscid + '/' + this.state.pointNameItem + '.png'))
          .then((url) => {
            if (pointSelectedType === 'EncabezadoSocial') {
              if (pointImgTarget === 'portada') {
                this.setState({
                  newContent: {
                    ...newContent,
                    metadata: {
                      ...newContent.metadata,
                      portadaSrc: url,
                    }
                  },
                  pointImgSample: url,
                  sampleImg: url,
                });
              } else if (pointImgTarget === 'perfil') {
                this.setState({
                  newContent: {
                    ...newContent,
                    metadata: {
                      ...newContent.metadata,
                      perfilSrc: url,
                    }
                  },
                  pointImgSample: url,
                  sampleImg: url,
                });
              }
            } else {
              
              this.setState({
                newContent: { ...newContent, src: url },
                pointImgSample: url,
                sampleImg: url,
              });
            }
          })
          .catch((error) => {
            console.error("Error al obtener URL", error);
          });
      } catch (e) {
        console.error("Error en loadResources", e);
      }
    };

    loadResources();
  }

  async handleTitleImg(c) {
    if (this.state.pointNameItem !== '') {
      await this.generateNewSSCID();
      let fileData = c.target.files[0]
      const storageRef = ref(storage, 'items/Thumbs/' + this.state.siteName + '/imgpage /' + this.state.sscid + '/' + this.state.pointNameItem + '.png');
      uploadBytes(storageRef, fileData).then((snapshot) => {
        this.getUrlTitle()
      })
    }
  }

  handleDeleteElement = () => {
    this.setState((prevState) => {
      const updatedContentMap = [...prevState.contentMap];
      updatedContentMap.splice(prevState.selectedContentIndex, 1);

      return {
        contentMap: updatedContentMap,
        selectedContentIndex: null,
        isFooterVisible: false,
      };
    }, this.handleUpdateConfStyle);
  };

  handleSaveContent = () => {
    const {
      pointSelectedType,
      newContent,
      contentMap,
      activeNavbarIndex,
      activeLinkIndex,
    } = this.state;

    if (!pointSelectedType || Object.keys(newContent).length === 0) {
      alert('Por favor completa el contenido antes de guardar.');
      return;
    }

    const contentToSave = {
      type: pointSelectedType,
      ...newContent,
    };
    if (typeof activeNavbarIndex === 'number' && typeof activeLinkIndex === 'number') {
      const updated = [...contentMap];
      updated[activeNavbarIndex].links[activeLinkIndex].metadata.push(contentToSave);

      this.setState(
        {
          contentMap: updated,
          newContent: {},
          modalCreateItem: false,
          pointSelectedType: 'LinkContentSelector',
        },
        () => this.handleUpdateCong()
      );
      console.log(this.state)
      return;
    }

    this.setState(
      {
        contentMap: [...contentMap, contentToSave],
        newContent: {},
        modalCreateItem: false,
      },
      () => this.handleUpdateCong()
    );
  };


  handleContentClick = (index) => {
    const selectedContent = this.state.contentMap[index];
    this.setState({
      selectedContentIndex: index,
      isFooterVisible: true,
      newContent: selectedContent,
    });
  };

  handleModifyContent = (e) => {
    const updatedContent = { ...this.state.newContent, style: { ...this.state.newContent.style, color: e.target.value } };
    this.setState({
      newContent: updatedContent,
      contentMap: this.state.contentMap.map((content, index) =>
        index === this.state.selectedContentIndex ? updatedContent : content
      ),
    });
  };

  handleAddContent = () => {
    const { pointSelectedType, newContent, contentMap, activeNavbarIndex, activeLinkIndex } = this.state;

    if (pointSelectedType === 'DynamicNavbar') {

      return;
    }

    if (typeof activeNavbarIndex === 'number' && typeof activeLinkIndex === 'number') {
      const updated = [...contentMap];
      updated[activeNavbarIndex].links[activeLinkIndex].metadata.push(newContent);

      this.setState({
        contentMap: updated,
        newContent: {},
        pointSelectedType: 'LinkContentSelector',
      });
      return;
    }

  };

  toggleSelectItem = (key) => {
    const { selectedItems = [], newContent = {}, itemsMap } = this.state;
    const isSelected = selectedItems.includes(key);

    const updatedSelectedItems = isSelected
      ? selectedItems.filter((id) => id !== key)
      : [...selectedItems, key];

    const selectedItemObjects = updatedSelectedItems.map((id) => ({
      key: id,
      name: itemsMap[id].name,
      src: itemsMap[id].src,
      price: itemsMap[id].priceItem,
      enableFxFlame: itemsMap[id].enableFxFlame,
    }));

    this.setState({
      selectedItems: updatedSelectedItems,
      newContent: {
        ...newContent,
        type: 'Marketplace',
        items: selectedItemObjects,
      },
    });
  };

  handleSaveMarketplaceBlock = () => {
    const { selectedItems = [], marketplaceDirection = 'vertical', itemsMap } = this.state;

    if (selectedItems.length === 0) return;
    console.log(selectedItems)

    const marketplaceBlock = {
      type: 'Marketplace',
      style: {},
      items: selectedItems.map((key) => ({
        key,
        name: itemsMap[key].name,
        src: itemsMap[key].src,
        price: itemsMap[key].priceItem,
        enableFxFlame: itemsMap[key].enableFxFlame,
        clicks: itemsMap[key].clicks || 0,
      })),
      direction: marketplaceDirection,
    };

    this.setState((prevState) => ({
      contentMap: [...prevState.contentMap, marketplaceBlock],
      showModal: false,
      selectedItems: [],
      marketplaceDirection: 'vertical',
    }));
  };

  renderModalContent = () => {
    const { selectedNavbarLink, pointSelectedType, newContent } = this.state;

    switch (pointSelectedType) {
      case 'Encabezado':
        return (
          <InputGroup>
            <FormControl
              placeholder="Título"
              onChange={(e) =>
                this.setState({
                  newContent: { ...newContent, title: e.target.value },
                })
              }
            />
          </InputGroup>
        );
      case 'Texto':
        return (
          <InputGroup>
            <FormControl
              as="textarea"
              placeholder="Escribe el texto"
              onChange={(e) =>
                this.setState({
                  newContent: { ...newContent, text: e.target.value },
                })
              }
            />
          </InputGroup>
        );
      case 'Marketplace':
        return (
          <div>
            <InputGroup className="mb-3">
              <InputGroup.Text>Dirección</InputGroup.Text>
              <FormSelect
                value={newContent?.direction ?? ''}
                onChange={(e) =>
                  this.setState({
                    newContent: {
                      ...newContent,
                      direction: e.target.value,
                    },
                  })
                }
              >
                <option value="vertical">Vertical</option>
                <option value="horizontal">Horizontal</option>
              </FormSelect>
            </InputGroup>

            <h6>Selecciona artículos:</h6>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {Object.entries(this.state.itemsMap).map(([key, item]) => (
                <div
                  key={key}
                  onClick={() => this.toggleSelectItem(key)}
                  style={{
                    border: this.state.selectedItems?.includes(key) ? '2px solid blue' : '1px solid #ccc',
                    padding: '10px',
                    cursor: 'pointer',
                    width: '120px',
                    textAlign: 'center',
                  }}
                >
                  <img src={item.src || this.state.NoImg} alt={item.name} style={{ width: '100%' }} />
                  <p style={{ fontSize: '14px' }}>{item.name}</p>
                </div>
              ))}
            </div>
          </div>
        );

      case 'Imagen':
      case 'Video':
        return (
          <InputGroup>
            <FormControl
              placeholder="URL del recurso"
              onChange={(e) =>
                this.setState({
                  newContent: { ...newContent, src: e.target.value },
                })
              }
            />
            <Button onClick={() => { this.crossBtnItemStore() }}>Cargar</Button>

          </InputGroup>
        );
      case 'DynamicNavbar':
        if (!selectedNavbarLink) return;

        const { navbarIndex, linkIndex } = selectedNavbarLink;
        return (
          <div>
            <InputGroup className="mb-2">
              <FormControl
                placeholder="Escribe un label para el link"
                value={this.state.tempLinkLabel || ''}
                onChange={(e) =>
                  this.setState({ tempLinkLabel: e.target.value })
                }
              />
              <Button
                onClick={() => {
                  const label = this.state.tempLinkLabel?.trim();
                  if (!label) return;
                  const newLinks = [
                    ...(this.state.newContent?.links || []),
                    {
                      label,
                      position: { x: 0, y: 0 },
                      metadata: [],
                    },
                  ];
                  this.setState({
                    newContent: {
                      ...this.state.newContent,
                      links: newLinks,
                    },
                    tempLinkLabel: '',
                  });
                }}
              >
                Agregar Link
              </Button>
            </InputGroup>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {(this.state.newContent?.links || []).map((link, i) => (
                <div
                  key={i}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#ddd',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    this.setState({
                      pointSelectedType: null,
                      modalCreateItem: true,
                      newContent: { direction: 'vertical', selectedItems: [] },
                    })
                  }
                >
                  {link.label}
                </div>
              ))}
            </div>
          </div>
        );
      case 'LinkContentSelector':
        return (
          <div>
            <h5>Agregar contenido al link</h5>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {['Texto', 'Encabezado', 'Imagen', 'Video'].map((type) => (
                <button
                  key={type}
                  onClick={() =>
                    this.setState({ pointSelectedType: type.toLowerCase() })
                  }
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>
        );

      case 'HeaderDesing':
        return (
          <>
            <h5>Opciones del Header</h5>
            <FormControl
              type="text"
              placeholder="Nombre de usuario"
              onChange={(e) =>
                this.setState({
                  newContent: {
                    ...newContent,
                    metadata: {
                      ...newContent.metadata,
                      userName: e.target.value,
                    },
                  },
                })
              }
            />
            <FormControl
              type="text"
              placeholder="Subtítulo"
              onChange={(e) =>
                this.setState({
                  newContent: {
                    ...newContent,
                    metadata: {
                      ...newContent.metadata,
                      userSubtitle: e.target.value,
                    },
                  },
                })
              }
            />
            <div>
              <h5>Imágenes del Encabezado</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => {
                  this.setState({ pointImgTarget: 'portada' }, () => this.crossBtnItemStore());
                }}
              >
                Subir imagen de portada
              </Button>
              {' '}
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  this.setState({ pointImgTarget: 'perfil' }, () => this.crossBtnItemStore());
                }}
              >
                Subir imagen de perfil
              </Button>
            </div>
          </>
        );
      default:
        return <p>Selecciona un tipo de contenido</p>;
    }
  };

  handleSelectContent = (index) => {
    const selectedContent = this.state.contentMap[index];
    this.setState({
      selectedContentIndex: index,
      selectedStyles: { ...selectedContent.style },
      isFooterVisible: true,
    });
  };

  handleModifyStyle = (e, forcedUnit = '') => {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const unit = forcedUnit || prevState.units?.[name] || '';
      const updatedStyles = {
        ...prevState.selectedStyles,
      };

      const stylesWithUnits = ['width', 'height', 'fontSize', 'letterSpacing'];

      if (stylesWithUnits.includes(name)) {
        updatedStyles[name] = value + unit;
      }

      else if (['shadowX', 'shadowY', 'shadowBlur', 'shadowOpacity'].includes(name)) {
        updatedStyles[name] = value;
        updatedStyles.textShadow = `${updatedStyles.shadowX || 0}px ${updatedStyles.shadowY || 0}px ${updatedStyles.shadowBlur || 0}px rgba(0, 0, 0, ${updatedStyles.shadowOpacity || 1})`;
      }
      else if (['strokeColor', 'strokeWidth'].includes(name)) {
        updatedStyles[name] = value;
        updatedStyles.WebkitTextStroke = `${updatedStyles.strokeWidth || 0}px ${updatedStyles.strokeColor || '#000'}`;
      }
      else if (name === 'rotate') {
        updatedStyles[name] = value;
        updatedStyles.transform = `rotate(${value}deg)`;
      }

      else {
        updatedStyles[name] = value;
      }

      const updatedContentMap = [...prevState.contentMap];
      if (updatedContentMap[prevState.selectedContentIndex]) {
        updatedContentMap[prevState.selectedContentIndex].style = updatedStyles;
      }

      return {
        selectedStyles: updatedStyles,
        contentMap: updatedContentMap,
      };
    });
  };

  handleSelectNavbarLink = (navbarIndex, linkIndex) => {
    this.setState({
      activeNavbarIndex: navbarIndex,
      activeLinkIndex: linkIndex,
      pointSelectedType: 'LinkContentSelector',
      newContent: {},
    });
  };

  handleDeleteNavbar = (index) => {
    const updated = [...this.state.contentMap];
    updated.splice(index, 1);
    this.setState({ contentMap: updated });
  };

  renderDynamicNavbarContent = (navbarIndex) => {
    const navbar = this.state.contentMap[navbarIndex];
    const selected = this.state.selectedNavbarLink;

    if (!selected || selected.navbarIndex !== navbarIndex) return null;

    const link = navbar.links[selected.linkIndex];

    return (
      <div style={{ marginTop: '40px' }}>
        <h6>Contenido de: {link.label}</h6>
        {link.metadata?.map((item, itemIndex) =>
          this.renderItem(item, `${navbarIndex}-${selected.linkIndex}-${itemIndex}`)
        )}
      </div>
    );
  };

  handleAddContentToNavbar = (navbarIndex) => {
    if (this.state.pointSelectedType === 'DynamicNavbar') {
      const { selectedNavbarLink, newContent, contentMap } = this.state;
      if (!selectedNavbarLink) return;

      const { navbarIndex, linkIndex } = selectedNavbarLink;

      const updatedContentMap = [...contentMap];
      updatedContentMap[navbarIndex].links[linkIndex].metadata.push(newContent);

      this.setState({
        contentMap: updatedContentMap,
        newContent: {},
      });
      return;
    }
  };

  renderItemContent = (content, index) => {
    switch (content.type) {
      case 'Texto':
        return (<p key={'texto-' + index} style={content.style}>{content.text}</p>);
      case 'Encabezado':
        return (<h2 key={'encabezado-' + index} style={content.style}>{content.title}</h2>);
      case 'Imagen':
        return (<img key={'img-' + index} src={content.src} alt="Contenido" style={{ maxWidth: '100%' }} />);
      case 'Video':
        return (
          <video key={'video-' + index} controls style={{ maxWidth: '100%' }}>
            <source src={content.src} type="video/mp4" />
          </video>
        );
      default:
        return null;
    }
  };

  handleDeleteContentItem = (contentIndex, rowIndex, colIndex, contentItemIndex) => {
    const updatedContentMap = [...this.state.contentMap];
    const colContents = updatedContentMap[contentIndex]
      ?.rows?.[rowIndex]
      ?.columns?.[colIndex]
      ?.contents;

    if (colContents && contentItemIndex >= 0) {
      colContents.splice(contentItemIndex, 1);
      this.setState({ contentMap: updatedContentMap });
    }
    this.handleUpdateCong()
  };

  handleSelectPexelsItem = (item) => {
    this.setState({
      tempContentData: item.src,
      searchQuery: '',
      searchResults: []
    });
  };

  handleSearchPexels = async () => {
    const { pexelsMode, searchQuery } = this.state;
    const API_KEY = 'VwynPxTsWDBz7tdrWNy5w5t15QHylKDVBReINhFcs4oQAC5fl1VWAkVj';

    const url =
      pexelsMode === 'Imagen'
        ? `https://api.pexels.com/v1/search?query=${searchQuery}&per_page=15`
        : `https://api.pexels.com/videos/search?query=${searchQuery}&per_page=10`;

    try {
      const res = await fetch(url, {
        headers: {
          Authorization: API_KEY
        }
      });
      const data = await res.json();

      const results =
        pexelsMode === 'Imagen'
          ? data.photos.map(photo => ({
            src: photo.src.medium,
            alt: photo.photographer
          }))
          : data.videos.map(video => ({
            src: video.video_files[0].link,
            title: video.user.name
          }));

      this.setState({ searchResults: results });
    } catch (err) {
      console.error('Error al buscar en Pexels:', err);
    }
  };

  handleSelectPexelsItem = (item) => {
    const { selectedContentIndex, selectedRowIndex, selectedColIndex, contentMap } = this.state;
    const updatedContentMap = [...contentMap];

    updatedContentMap[selectedContentIndex]
      .rows[selectedRowIndex]
      .columns[selectedColIndex]
      .contents.push({
        type: this.state.pexelsMode,
        data: item,
        style: {}
      });

    this.setState({
      contentMap: updatedContentMap,
      showPexelsModal: false,
      searchQuery: '',
      searchResults: []
    });
  };

  renderContent = () => {
    const { contentMap, activeNavbarIndex, pointSelectedType, activeLinkIndex, newContent } = this.state;

    return contentMap.map((content, index) => {
      switch (content.type) {
        case 'Encabezado':
          return (
            <div className={`animated ${content.style?.animation || ''}`} key={'encabezado-' + index}>
              <h2 className={`animated ${content.style?.animation || ''}`} onClick={() => this.handleSelectContent(index)} id={'a' + index} style={content.style}>{content.title}</h2>
              <br />
            </div>
          )
        case 'Texto':
          return (<p className={`animated ${content.style?.animation || ''}`} key={'texto-' + index} style={content.style} onClick={() => this.handleSelectContent(index)}>{content.text}</p>)
        case 'Imagen':
          return (<img className={`animated ${content.style?.animation || ''}`} key={'img-' + index} onClick={() => this.handleSelectContent(index)} src={content.src} alt="Contenido" style={{ maxWidth: '100%' }} />);
        case 'Video':
          return (
            <video key={'video-' + index} controls style={{ maxWidth: '100%' }}>
              <source src={content.src} type="video/mp4" />
            </video>
          );
        case 'Carousel':
          return (
            <div key={'carousel-' + index} onClick={() => this.handleSelectContent(index)} style={{ maxWidth: '100%' }}>
              <Carousel>
                {content.items.map((item, i) => (
                  <Carousel.Item key={i}>
                    <img
                      src={item.src}
                      alt={`Slide ${i}`}
                      style={{ width: '100%' }}
                    />
                    {item.caption && (
                      <Carousel.Caption>
                        <h3>{item.caption.title}</h3>
                        <p>{item.caption.text}</p>
                      </Carousel.Caption>
                    )}
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          );

        case 'Grid':
          return (
            <div
              key={index}
              onClick={() => this.handleSelectContent(index)}
              className="container"
              style={content.style}
            >
              {content.rows.map((row, rowIndex) => (
                <div key={rowIndex} className="row mb-3" style={{ backgroundColor: row.backgroundColor || 'transparent' }}>
                  {row.columns.map((col, colIndex) => {
                    const isSelected =
                      index === this.state.selectedContentIndex &&
                      rowIndex === this.state.selectedRowIndex &&
                      colIndex === this.state.selectedColIndex;

                    return (
                      <div
                        key={colIndex}
                        className={`col-md-${col.size || 12}`}
                        style={{
                          border: isSelected ? '2px solid blue' : 'none',
                          padding: '10px',
                          cursor: 'pointer',
                          backgroundColor: col.backgroundColor || 'white',
                          ...col.style,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleSelectContent(index);
                          this.handleSelectGridCol(rowIndex, colIndex);
                        }}
                      >
                        {col.contents && col.contents.map((item, itemIndex) => (
                          <div key={itemIndex} style={{ position: 'relative', marginBottom: '10px' }}>
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                const confirmDelete = window.confirm('¿Estás seguro de que quieres eliminar este contenido?');
                                if (confirmDelete) {
                                  this.handleDeleteContentItem(index, rowIndex, colIndex, itemIndex);
                                }
                              }}
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                background: '#dc3545',
                                color: 'white',
                                borderRadius: '50%',
                                padding: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '24px',
                                height: '24px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                              }}
                              title="Eliminar contenido"
                            >
                              🗑️
                            </span>

                            {(() => {
                              switch (item.type) {
                                case 'Texto':
                                  return <p style={item.style}>{item.data}</p>;
                                case 'Imagen':
                                  return (
                                    <img
                                      src={item.data.src}
                                      alt={item.data.alt || 'Imagen'}
                                      style={{ maxWidth: '100%', ...item.style }}
                                    />
                                  );
                                case 'Lista':
                                  return (
                                    <ul style={item.style}>
                                      {item.data.map((line, i) => (
                                        <li key={i}>{line}</li>
                                      ))}
                                    </ul>
                                  );
                                case 'Video':
                                  return (
                                    <iframe
                                      src={item.data.src}
                                      title={item.data.title || 'Video'}
                                      style={item.style}
                                      allowFullScreen
                                    />
                                  );
                                case 'Separador':
                                  return (
                                    <hr
                                      style={{
                                        border: 'none',
                                        borderTop: '2px dashed #999',
                                        margin: '20px 0',
                                        ...item.style,
                                      }}
                                    />
                                  );
                                default:
                                  return <div>Contenido no reconocido</div>;
                              }
                            })()}
                          </div>
                        ))}

                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          );
        case 'Marketplace':
          return (
            <div
              key={'market-' + index}
              onClick={() => this.handleSelectContent(index)}
              style={{
                display: 'flex',
                flexDirection: content.direction === 'horizontal' ? 'row' : 'column',
                gap: '15px',
                flexWrap: 'wrap',
                alignItems: 'center',
                padding: '10px',
              }}
            >
              {content.items.map((item, i) => (
                <div
                  key={item.name + i}
                  style={{
                    border: '1px solid #ddd',
                    padding: '10px',
                    textAlign: 'center',
                    width: '150px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '2px 2px 5px rgba(0,0,0,0.1)'
                  }}
                >
                  <img src={item.src} alt={item.name} style={{ width: '100%', height: 'auto', borderRadius: '5px' }} />
                  <div className={`${item.enableFxFlame || ''} flame-container-page`}>
                    <svg className="flame" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#FF5722" d="M32,4C32,4,2,24,8,46c3.889,14.11,24,18,24,18s20.111-3.89,24-18C62,24,32,4,32,4z" />
                      <path fill="#FF7043" d="M32,14c0,0-14.4,10.6-9.6,26.4C25.6,46.4,32,48,32,48s6.4-1.6,9.6-7.6C46.4,24.6,32,14,32,14z" />
                      <path fill="#FF8A65" d="M32,26c0,0-5.3,3.9-3.2,10.8C30.1,40.3,32,41,32,41s1.9-0.7,3.2-4.2C37.3,29.9,32,26,32,26z" />
                    </svg>
                  </div>
                  <p style={{ fontSize: '14px', margin: '5px 0', fontWeight: 'bold' }}>{item.name}</p>
                  <p style={{ fontSize: '13px', color: '#888' }}>${item.price}</p>
                </div>
              ))}
            </div>
          );
        case 'DynamicNavbar':
          return (
            <div key={index} style={content.style} className="navbar-dynamic">
              <div style={{ display: 'flex', gap: '20px', position: 'relative' }}>
                {content.links.map((link, i) => (
                  <div
                    key={`link-${index}-${i}`}
                    style={{
                      left: link.position.x,
                      top: link.position.y,
                      borderBottom: '1px solid #000',
                      padding: '5px 10px',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                    }}
                    onClick={() => this.handleSelectNavbarLink(index, i)}
                  >
                    {link.label}
                  </div>
                ))}
                <button
                  onClick={() => this.handleDeleteNavbar(index)}
                  style={{
                    position: 'absolute',
                    right: -15,
                    top: -15,
                    borderRadius: '50%',
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    width: 30,
                    height: 30,
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  X
                </button>
              </div>
              {pointSelectedType === 'LinkContentSelector' && typeof activeNavbarIndex === 'number' && typeof activeLinkIndex === 'number' && (
                <div style={{ marginTop: 20 }}>
                  <h6>Contenido de: {contentMap[activeNavbarIndex].links[activeLinkIndex].label}</h6>

                  <button
                    className="btn btn-primary mb-3"
                    onClick={() => this.setState({ pointSelectedType: '', modalCreateItem: true })}
                  >
                    + Agregar contenido
                  </button>
                  {contentMap[activeNavbarIndex].links[activeLinkIndex].metadata?.map((item, index) =>
                    this.renderItemContent(item, `link-${activeNavbarIndex}-${activeLinkIndex}-${index}`)
                  )}
                </div>
              )}

              {this.renderDynamicNavbarContent(index)}
            </div>
          );

        case 'Separador':
          return (
            <div className={`animated ${content.style?.animation || ''}`} key={'separador-' + index} style={{ width: '100%', height: '100%' }}>
              <div
                onClick={() => this.handleSelectContent(index)}
                id={'a' + index}
                style={{
                  width: '100%',
                  height: '100%',
                  borderTop: content.style?.borderTop || '2px dashed #999',
                  margin: content.style?.margin || '20px 0',
                }}
              />
              <br />
            </div>
          );
        case 'HeaderDesing':
          const {
            portadaSrc,
            perfilSrc,
            userName,
            userSubtitle,
            perfilStyle,
            textoStyle,
          } = content.metadata;

          return (
            <div key={'header-' + index} style={content.style}>
              {content.src && (
                <img
                  src={content.src}
                  alt="Portada"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              )}
              {perfilSrc && (
                <img
                  src={perfilSrc}
                  alt="Perfil"
                  style={perfilStyle}
                />
              )}
              <div style={textoStyle}>
                <h3>{userName}</h3>
                <p>{userSubtitle}</p>
              </div>
            </div>
          );

        default:
          return null;
      }
    });
  };


  handleModifyGridSize = (rowIndex, colIndex, event) => {
    const newSize = parseInt(event.target.value, 10);

    this.setState((prevState) => {
      const updatedContentMap = [...prevState.contentMap];
      const selectedIndex = prevState.selectedContentIndex;

      if (selectedIndex !== null) {
        updatedContentMap[selectedIndex].rows[rowIndex].columns[colIndex].size = newSize;
      }

      return { contentMap: updatedContentMap };
    });
  };

  handleSelectGridCol = (rowIndex, colIndex) => {
    this.setState({
      selectedRowIndex: rowIndex,
      selectedColIndex: colIndex,
    });
  };

  updateSelectedContentStyle = () => {
    this.setState((prevState) => {
      const updatedContentMap = [...prevState.contentMap];
      if (updatedContentMap[prevState.selectedContentIndex]) {
        updatedContentMap[prevState.selectedContentIndex].style = {
          ...prevState.selectedStyles
        };
      }

      return { contentMap: updatedContentMap };
    });
  };

  handleModifyColumnStyle = (styleKey, value) => {
    const { selectedContentIndex, selectedRowIndex, selectedColIndex, contentMap } = this.state;
    const updatedContent = [...contentMap];

    const targetColumn = updatedContent[selectedContentIndex].rows[selectedRowIndex].columns[selectedColIndex];

    if (!targetColumn.style) {
      targetColumn.style = {};
    }

    targetColumn.style[styleKey] = value;

    this.setState({ contentMap: updatedContent });
  };

  handleUnitChange = (prop, unit) => {
    this.setState((prevState) => {
      const currentValue = parseInt(prevState.selectedStyles[prop]) || 0;

      return {
        units: {
          ...prevState.units,
          [prop]: unit
        },
        selectedStyles: {
          ...prevState.selectedStyles,
          [prop]: currentValue + unit
        }
      };
    }, this.updateSelectedContentStyle);
  };

  applyPresetStyle = (styleName) => {
    const presets = {
      neon: {
        color: '#39ff14',
        textShadow: '0 0 5px #39ff14, 0 0 10px #39ff14, 0 0 20px #39ff14',
        fontWeight: 'bold',
        fontFamily: 'Arial Black'
      },
      comic: {
        color: '#ff6600',
        fontFamily: 'Comic Sans MS',
        letterSpacing: '1px',
        fontWeight: 'bold'
      }
    };

    const newStyle = { ...this.state.selectedStyles, ...presets[styleName] };
    const updatedContentMap = [...this.state.contentMap];
    updatedContentMap[this.state.selectedContentIndex].style = newStyle;

    this.setState({
      selectedStyles: newStyle,
      contentMap: updatedContentMap
    });

    this.handleUpdateCong()
  };

  handleModifyColumnType = (newType) => {
    const {
      selectedContentIndex,
      selectedRowIndex,
      selectedColIndex,
      contentMap
    } = this.state;

    const updatedContentMap = [...contentMap];
    const column = updatedContentMap[selectedContentIndex].rows[selectedRowIndex].columns[selectedColIndex];

    if (!column.contents) column.contents = [];

    let newContentItem = {
      type: newType,
      data: newType === 'Lista' ? [] : '',
      style: {}
    };

    column.contents.push(newContentItem);

    this.setState({
      contentMap: updatedContentMap,
      selectedContentItemIndex: column.contents.length - 1,
      currentEditType: newType,
      showContentModal: true,
      tempContentData: '',
      tempContentExtra: ''
    });
    this.handleUpdateCong()
  };

  handleSaveContentRow = () => {
    const {
      selectedContentIndex,
      selectedRowIndex,
      selectedColIndex,
      selectedContentItemIndex,
      contentMap,
      currentEditType,
      tempContentData,
      tempContentExtra
    } = this.state;


    const updatedContentMap = [...contentMap];
    const contentItem =
      updatedContentMap[selectedContentIndex]
        .rows[selectedRowIndex]
        .columns[selectedColIndex]
        .contents[selectedContentItemIndex];

    switch (currentEditType) {
      case 'Texto':
        contentItem.data = tempContentData;
        break;
      case 'Imagen':
        contentItem.data = {
          src: tempContentData,
          alt: tempContentExtra
        };
        break;
      case 'Video':
        contentItem.data = {
          src: tempContentData,
          title: tempContentExtra
        };
        break;
      case 'Lista':
        contentItem.data = tempContentData.split('\n').filter((item) => item.trim() !== '');
        break;
      default:
        break;
    }

    this.setState({
      contentMap: updatedContentMap,
      showContentModal: false,
      currentEditType: null,
      tempContentData: '',
      tempContentExtra: ''
    });
    this.handleUpdateCong()
  };


  render() {
    const { choiseColorBackground, newContent, modalCreateItem, pointSelectedType, contentList, isFooterVisible, pointSelectedContentId, selectedContentIndex } = this.state;

    return (
      <>
        <div style={{ choiseColorBackground, marginBottom: this.state.isFooterVisible ? '200px' : '0px' }} className='App-header '>
          <div className="btn-sty t-0" onClick={this.handleCreateContainer}>
            <FaCirclePlus />
          </div>
          {this.renderContent()}
          <Modal show={modalCreateItem} onHide={() => this.setState({ modalCreateItem: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Crear Contenido</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <InputGroup className="mb-3">
                <FormControl
                  as="select"
                  value={pointSelectedType}
                  onChange={(e) => this.setState({ pointSelectedType: e.target.value })}
                >
                  <option value="">Selecciona un tipo</option>
                  <option value="Encabezado">Encabezado</option>
                  <option value="Texto">Texto</option>
                  <option value="Imagen">Imagen</option>
                  <option value="Video">Video</option>
                  <option value="Carousel">Carousel</option>
                  <option value="Marketplace">Espacio de Marketplace</option>
                  <option value="Grid">Grid</option>
                  <option value="Separador">Separador</option>
                  <option value="HeaderDesing">Encabezado </option>
                  {/*<option value="DynamicNavbar">Navbar Dinámico</option>*/}
                </FormControl>
              </InputGroup>
              {this.renderModalContent()}
              {pointSelectedType === 'Encabezado' || pointSelectedType === 'Texto' ? (
                <div>
                  <h5>Opciones de Estilo</h5>
                  <InputGroup className="mb-3">
                    <FormControl
                      type="color"
                      title="Color de fuente"
                      onChange={(e) =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            style: { ...newContent.style, color: e.target.value },
                          },
                        })
                      }
                    />
                    <FormControl
                      type="number"
                      placeholder="Tamaño de fuente (px)"
                      onChange={(e) =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            style: { ...newContent.style, fontSize: `${e.target.value}px` },
                          },
                        })
                      }
                    />
                  </InputGroup>
                  <div className="mb-3">
                    <h6>Mover Posición</h6>
                    <InputGroup>
                      <FormControl
                        type="number"
                        placeholder="Top (px)"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: { ...newContent.style, top: `${e.target.value}px` },
                            },
                          })
                        }
                      />
                      <FormControl
                        type="number"
                        placeholder="Left (px)"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: { ...newContent.style, left: `${e.target.value}px` },
                            },
                          })
                        }
                      />
                    </InputGroup>
                  </div>
                  <div className="mb-3">
                    <label>
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: {
                                ...newContent.style,
                                textShadow: e.target.checked
                                  ? '2px 2px 5px rgba(0,0,0,0.3)'
                                  : 'none',
                              },
                            },
                          })
                        }
                      />{' '}
                      Sombra de texto
                    </label>
                  </div>
                  <div className="mb-3">
                    <label>
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: {
                                ...newContent.style,
                                textDecoration: e.target.checked ? 'underline' : 'none',
                              },
                            },
                          })
                        }
                      />{' '}
                      Subrayado
                    </label>
                  </div>
                </div>
              ) : null}
              {pointSelectedType === 'Carousel' && (
                <div>
                  <h5>Crear Carousel</h5>
                  <div>
                    {newContent.items?.map((item, index) => (
                      <div key={index} className="mb-3">
                        <InputGroup className="mb-2">
                          <FormControl
                            type="text"
                            placeholder={`Imagen ${index + 1} URL`}
                            value={item.src || ''}
                            onChange={(e) => {
                              const updatedItems = [...newContent.items];
                              updatedItems[index] = { ...updatedItems[index], src: e.target.value };
                              this.setState({
                                newContent: { ...newContent, items: updatedItems },
                              });
                            }}
                          />
                          <Button
                            variant="danger"
                            onClick={() => {
                              const updatedItems = [...newContent.items];
                              updatedItems.splice(index, 1);
                              this.setState({
                                newContent: { ...newContent, items: updatedItems },
                              });
                            }}
                          >
                            -
                          </Button>
                        </InputGroup>
                        <InputGroup className="mb-2">
                          <FormControl
                            type="text"
                            placeholder="Título (opcional)"
                            value={item.caption?.title || ''}
                            onChange={(e) => {
                              const updatedItems = [...newContent.items];
                              updatedItems[index] = {
                                ...updatedItems[index],
                                caption: { ...updatedItems[index].caption, title: e.target.value },
                              };
                              this.setState({
                                newContent: { ...newContent, items: updatedItems },
                              });
                            }}
                          />
                        </InputGroup>
                        <InputGroup>
                          <FormControl
                            type="text"
                            placeholder="Texto (opcional)"
                            value={item.caption?.text || ''}
                            onChange={(e) => {
                              const updatedItems = [...newContent.items];
                              updatedItems[index] = {
                                ...updatedItems[index],
                                caption: { ...updatedItems[index].caption, text: e.target.value },
                              };
                              this.setState({
                                newContent: { ...newContent, items: updatedItems },
                              });
                            }}
                          />
                        </InputGroup>
                      </div>
                    ))}
                    <Button
                      variant="success"
                      onClick={() =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            items: [...(newContent.items || []), { src: '', caption: {} }],
                          },
                        })
                      }
                    >
                      + Agregar Imagen
                    </Button>
                  </div>
                </div>
              )}
              {pointSelectedType === 'Navbar' && (
                <div>
                  <h5>Crear Navbar</h5>
                  <InputGroup className="mb-3">
                    <FormControl
                      type="text"
                      placeholder="Título del Navbar"
                      value={newContent.navTitle || ''}
                      onChange={(e) =>
                        this.setState({
                          newContent: { ...newContent, navTitle: e.target.value },
                        })
                      }
                    />
                  </InputGroup>
                  <div>
                    <h6>Vínculos del Navbar</h6>
                    {newContent.links?.map((link, index) => (
                      <InputGroup key={index} className="mb-3">
                        <FormControl
                          type="text"
                          placeholder={`Texto del vínculo ${index + 1}`}
                          value={link.text || ''}
                          onChange={(e) => {
                            const updatedLinks = [...newContent.links];
                            updatedLinks[index] = { ...updatedLinks[index], text: e.target.value };
                            this.setState({
                              newContent: { ...newContent, links: updatedLinks },
                            });
                          }}
                        />
                        <FormControl
                          type="text"
                          placeholder={`URL del vínculo ${index + 1}`}
                          value={link.url || ''}
                          onChange={(e) => {
                            const updatedLinks = [...newContent.links];
                            updatedLinks[index] = { ...updatedLinks[index], url: e.target.value };
                            this.setState({
                              newContent: { ...newContent, links: updatedLinks },
                            });
                          }}
                        />
                        <Button
                          variant="danger"
                          onClick={() => {
                            const updatedLinks = [...newContent.links];
                            updatedLinks.splice(index, 1);
                            this.setState({
                              newContent: { ...newContent, links: updatedLinks },
                            });
                          }}
                        >
                          -
                        </Button>
                      </InputGroup>
                    ))}
                    <Button
                      variant="success"
                      onClick={() =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            links: [...(newContent.links || []), { text: '', url: '' }],
                          },
                        })
                      }
                    >
                      + Agregar Vínculo
                    </Button>
                  </div>
                </div>
              )}
              {pointSelectedType === 'Grid' && (
                <div>
                  <h5>Crear Grid (Filas y Columnas)</h5>
                  <div>
                    {newContent.rows?.map((row, rowIndex) => (
                      <div key={rowIndex} className="mb-3">
                        <h6>Fila {rowIndex + 1}</h6>
                        {row.columns.map((col, colIndex) => (
                          <InputGroup key={colIndex} className="mb-2">
                            <FormControl
                              type="text"
                              placeholder={`Contenido Columna ${colIndex + 1}`}
                              value={col.content || ''}
                              onChange={(e) => {
                                const updatedRows = [...newContent.rows];
                                updatedRows[rowIndex].columns[colIndex].content = e.target.value;
                                this.setState({
                                  newContent: { ...newContent, rows: updatedRows },
                                });
                              }}
                            />
                            <FormControl
                              type="number"
                              placeholder="Tamaño de Columna (1-12)"
                              value={col.size || ''}
                              onChange={(e) => {
                                const updatedRows = [...newContent.rows];
                                updatedRows[rowIndex].columns[colIndex].size = e.target.value;
                                this.setState({
                                  newContent: { ...newContent, rows: updatedRows },
                                });
                              }}
                            />
                            <Button
                              variant="danger"
                              onClick={() => {
                                const updatedRows = [...newContent.rows];
                                updatedRows[rowIndex].columns.splice(colIndex, 1);
                                this.setState({
                                  newContent: { ...newContent, rows: updatedRows },
                                });
                              }}
                            >
                              -
                            </Button>
                          </InputGroup>
                        ))}
                        <Button
                          variant="success"
                          onClick={() => {
                            const updatedRows = [...newContent.rows];
                            updatedRows[rowIndex].columns.push({ size: 12, content: '' });
                            this.setState({
                              newContent: { ...newContent, rows: updatedRows },
                            });
                          }}
                        >
                          + Agregar Columna
                        </Button>
                      </div>
                    ))}
                    <Button
                      variant="primary"
                      onClick={() =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            rows: [...(newContent.rows || []), { columns: [{ size: 12, content: '' }] }],
                          },
                        })
                      }
                    >
                      + Agregar Fila
                    </Button>
                  </div>
                </div>
              )}
              {pointSelectedType === 'Separador' && (
                <div>
                  <h5>Opciones de Separador</h5>

                  <Form.Group className="mb-3">
                    <Form.Label>Color</Form.Label>
                    <Form.Control
                      type="color"
                      value={newContent?.style?.borderColor || '#999999'}
                      onChange={(e) =>
                        this.setState({
                          newContent: {
                            ...newContent,
                            style: {
                              ...newContent.style,
                              borderTop: `2px dashed ${e.target.value}`,
                              borderColor: e.target.value,
                            },
                          },
                        })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de línea</Form.Label>
                    <Form.Select
                      value={newContent?.borderStyle || 'dashed'}
                      onChange={(e) => {
                        const styleType = e.target.value;
                        const currentColor = newContent?.style?.borderColor || '#999999';
                        this.setState({
                          newContent: {
                            ...newContent,
                            borderStyle: styleType,
                            style: {
                              ...newContent.style,
                              borderTop: `2px ${styleType} ${currentColor}`,
                            },
                          },
                        });
                      }}
                    >
                      <option value="solid">Sólida</option>
                      <option value="dashed">Discontinua</option>
                      <option value="dotted">Punteada</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Espaciado</Form.Label>
                    <InputGroup>
                      <FormControl
                        type="number"
                        placeholder="Margen superior"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: {
                                ...newContent.style,
                                marginTop: `${e.target.value}px`,
                              },
                            },
                          })
                        }
                      />
                      <FormControl
                        type="number"
                        placeholder="Margen inferior"
                        onChange={(e) =>
                          this.setState({
                            newContent: {
                              ...newContent,
                              style: {
                                ...newContent.style,
                                marginBottom: `${e.target.value}px`,
                              },
                            },
                          })
                        }
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              )}

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ modalCreateItem: false })}>
                Cancelar
              </Button>
              <Button variant="primary" onClick={this.handleSaveContent}>
                Guardar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div>
          <div>
            {contentList.map((content, index) => (
              <div key={index} style={content.style}>
                {content.text}
                <button
                  onClick={() =>
                    this.setState({ pointSelectedContentId: index, isFooterVisible: true })
                  }
                >
                  ^
                </button>
              </div>
            ))}
          </div>
          {this.state.isFooterVisible && (
            <footer
              style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                height: '25%',
                width: '100%',
                background: '#fff',
                padding: '1rem',
                overflowY: 'scroll',
                boxShadow: '0 -2px 5px rgba(0,0,0,0.2)',
              }}
            >
              {this.state.selectedContentIndex !== null ? (
                <div>
                  <h5>Editando {this.state.contentMap[this.state.selectedContentIndex].type}</h5>
                  <Row>
                    <Col>
                      <div>
                        <label>Width:</label>
                        <input
                          type="number"
                          name="width"
                          value={parseInt(this.state.selectedStyles.width) || ''}
                          onChange={(e) => this.handleModifyStyle(e)}
                        />
                        <select
                          value={this.state.units.width || 'px'}
                          onChange={(e) => this.handleUnitChange('width', e.target.value)}
                        >
                          <option value="px">px</option>
                          <option value="%">%</option>
                        </select>

                        {this.state.units.width === '%' && (
                          <input
                            type="range"
                            min="0"
                            max="100"
                            name="width"
                            value={parseInt(this.state.selectedStyles.width) || 0}
                            onChange={(e) => this.handleModifyStyle(e)}
                          />
                        )}

                        <label className="mt-2">Height:</label>
                        <input
                          type="number"
                          name="height"
                          value={parseInt(this.state.selectedStyles.height) || ''}
                          onChange={(e) => this.handleModifyStyle(e)}
                        />
                        <select
                          value={this.state.units.height || 'px'}
                          onChange={(e) => this.handleUnitChange('height', e.target.value)}
                        >
                          <option value="px">px</option>
                          <option value="%">%</option>
                        </select>

                        {this.state.units.height === '%' && (
                          <input
                            type="range"
                            min="0"
                            max="100"
                            name="height"
                            value={parseInt(this.state.selectedStyles.height) || 0}
                            onChange={(e) => this.handleModifyStyle(e)}
                          />
                        )}
                      </div>
                      <label>Animación:</label>
                      <select
                        name="animation"
                        value={this.state.selectedStyles.animation || ''}
                        onChange={this.handleModifyStyle}
                      >
                        <option value="">Ninguna</option>
                        <option value="bounce">Rebote</option>
                        <option value="pulse">Pulso</option>
                        <option value="flash">Destello</option>
                        <option value="fadeIn">Desvanecer</option>
                        <option value="zoomIn">Zoom</option>
                      </select>

                      <div style={{ marginTop: '10px' }}>
                        <strong>Estilos rápidos:</strong><br />
                        <button onClick={() => this.applyPresetStyle('neon')}>💡 Neon</button>
                        <button onClick={() => this.applyPresetStyle('comic')}>🗯️ Comic</button>
                      </div>
                    </Col>
                    {['Encabezado', 'Texto'].includes(this.state.contentMap[this.state.selectedContentIndex].type) && (
                      <>
                        <Col>
                          <label>Color de fuente:</label>
                          <input
                            type="color"
                            name="color"
                            value={this.state.selectedStyles.color || '#000000'}
                            onChange={this.handleModifyStyle}
                          />
                          <label>Tamaño de fuente:</label>
                          <input
                            type="number"
                            name="fontSize"
                            value={parseInt(this.state.selectedStyles.fontSize) || 16}
                            onChange={(e) => this.handleModifyStyle(e, 'px')}
                          />
                          <label>Color del borde:</label>
                          <input
                            type="color"
                            name="strokeColor"
                            value={this.state.selectedStyles.strokeColor || '#000000'}
                            onChange={this.handleModifyStyle}
                          />

                          <label>Grosor del borde:</label>
                          <input
                            type="number"
                            name="strokeWidth"
                            value={this.state.selectedStyles.strokeWidth || 0}
                            onChange={this.handleModifyStyle}
                          />
                          <label>Espaciado entre letras:</label>
                          <input
                            type="number"
                            name="letterSpacing"
                            value={parseFloat(this.state.selectedStyles.letterSpacing) || 0}
                            onChange={(e) => this.handleModifyStyle(e, 'px')}
                          />

                          <label>Espaciado entre líneas:</label>
                          <input
                            type="number"
                            name="lineHeight"
                            value={this.state.selectedStyles.lineHeight || 1.2}
                            step="0.1"
                            onChange={this.handleModifyStyle}
                          />
                          <label>Rotación:</label>
                          <input
                            type="number"
                            name="rotate"
                            value={this.state.selectedStyles.rotate || 0}
                            onChange={(e) => this.handleModifyStyle(e, 'deg')}
                          />
                        </Col>
                        <Col>
                          <label>Fuente:</label>
                          <select
                            name="fontFamily"
                            value={this.state.selectedStyles.fontFamily || 'Arial'}
                            onChange={this.handleModifyStyle}
                          >
                            <option value="Arial">Arial</option>
                            <option value="Verdana">Verdana</option>
                            <option value="Courier New">Courier New</option>
                            <option value="Times New Roman">Times New Roman</option>

                          </select>

                          <label>Negrita:</label>
                          <input
                            type="checkbox"
                            checked={this.state.selectedStyles.fontWeight === 'bold'}
                            onChange={(e) =>
                              this.handleModifyStyle({ target: { name: 'fontWeight', value: e.target.checked ? 'bold' : 'normal' } })
                            }
                          />
                          <label>Cursiva:</label>
                          <input
                            type="checkbox"
                            checked={this.state.selectedStyles.fontStyle === 'italic'}
                            onChange={(e) =>
                              this.handleModifyStyle({ target: { name: 'fontStyle', value: e.target.checked ? 'italic' : 'normal' } })
                            }
                          />
                          <label>Subrayado:</label>
                          <input
                            type="checkbox"
                            checked={this.state.selectedStyles.textDecoration === 'underline'}
                            onChange={(e) =>
                              this.handleModifyStyle({ target: { name: 'textDecoration', value: e.target.checked ? 'underline' : 'none' } })
                            }
                          />
                          <div>
                            <label>Sombra de texto:</label>
                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                              <div style={{ textAlign: 'center' }}>
                                <input
                                  type="number"
                                  name="shadowX"
                                  value={this.state.selectedStyles.shadowX || 0}
                                  onChange={this.handleModifyStyle}
                                  style={{ width: '50px' }}
                                />
                                <div>↔️</div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <input
                                  type="number"
                                  name="shadowY"
                                  value={this.state.selectedStyles.shadowY || 0}
                                  onChange={this.handleModifyStyle}
                                  style={{ width: '50px' }}
                                />
                                <div>↕️</div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <input
                                  type="number"
                                  name="shadowBlur"
                                  value={this.state.selectedStyles.shadowBlur || 0}
                                  onChange={this.handleModifyStyle}
                                  style={{ width: '50px' }}
                                />
                                <div>🌫️</div>
                              </div>
                              <div style={{ textAlign: 'center' }}>
                                <input
                                  type="number"
                                  name="shadowOpacity"
                                  step="0.1"
                                  min="0"
                                  max="1"
                                  value={this.state.selectedStyles.shadowOpacity || 1}
                                  onChange={this.handleModifyStyle}
                                  style={{ width: '50px' }}
                                />
                                <div>🔆</div>
                              </div>

                            </div>

                          </div>
                        </Col>
                      </>
                    )}
                    {['Imagen', 'Video'].includes(this.state.contentMap[this.state.selectedContentIndex].type) && (
                      <>
                        <Col>
                          <label>Borde redondeado:</label>
                          <input
                            type="text"
                            name="borderRadius"
                            value={this.state.selectedStyles.borderRadius || '0px'}
                            onChange={this.handleModifyStyle}
                          />
                          <label>Object Fit:</label>
                          <select
                            name="objectFit"
                            value={this.state.selectedStyles.objectFit || 'fill'}
                            onChange={this.handleModifyStyle}
                          >
                            <option value="fill">Fill</option>
                            <option value="contain">Contain</option>
                            <option value="cover">Cover</option>
                            <option value="none">None</option>
                          </select>
                        </Col>
                      </>
                    )}
                    {this.state.contentMap[this.state.selectedContentIndex].type === 'Grid' && (
                      <Col>
                        <h5>Configurar Columnas</h5>
                        {this.state.contentMap[this.state.selectedContentIndex].rows.map((row, rowIndex) => (
                          <div key={rowIndex}>
                            <h6>Fila {rowIndex + 1}</h6>
                            {row.columns.map((col, colIndex) => (
                              <div key={colIndex}>
                                <label>Columna {colIndex + 1} (1-12)</label>
                                <input
                                  type="number"
                                  name={`col-${colIndex}`}
                                  min="1"
                                  max="12"
                                  value={col.size}
                                  onChange={(e) => this.handleModifyGridSize(rowIndex, colIndex, e)}
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                      </Col>
                    )}
                    {this.state.contentMap[this.state.selectedContentIndex].type === 'Carousel' && (
                      <Col>
                        <label>Margen:</label>
                        <input
                          type="text"
                          name="margin"
                          value={this.state.selectedStyles.margin || '0px'}
                          onChange={(e) => this.handleModifyStyle(e, 'px')}
                        />
                      </Col>
                    )}

                    {this.state.contentMap[this.state.selectedContentIndex]?.type === 'Grid' &&
                      typeof this.state.selectedRowIndex === 'number' &&
                      typeof this.state.selectedColIndex === 'number' && (
                        <Col>
                          <h5>Editar Columna {this.state.selectedColIndex + 1} de la Fila {this.state.selectedRowIndex + 1}</h5>

                          <label>Tamaño (1-12):</label>
                          <input
                            type="number"
                            min="1"
                            max="12"
                            value={
                              this.state.contentMap[this.state.selectedContentIndex].rows[this.state.selectedRowIndex].columns[this.state.selectedColIndex].size || 12
                            }
                            onChange={(e) => this.handleModifyGridSize(this.state.selectedRowIndex, this.state.selectedColIndex, e)}
                          /><label>Contenido:</label>
                          <select
                            value={
                              this.state.contentMap[this.state.selectedContentIndex]
                                .rows[this.state.selectedRowIndex]
                                .columns[this.state.selectedColIndex]
                                .contents?.[this.state.selectedContentItemIndex]?.type || 'Seleccionar'
                            }
                            onChange={(e) => this.handleModifyColumnType(e.target.value)}
                          >
                            <option value="Seleccionar">Seleccionar</option>
                            <option value="Texto">Texto</option>
                            <option value="Imagen">Imagen</option>
                            <option value="Video">Video</option>
                            <option value="Lista">Lista</option>
                            <option value="Separador">Separador</option>
                          </select>
                          <label>Justify Content:</label>
                          <select
                            value={
                              this.state.contentMap[this.state.selectedContentIndex].rows[this.state.selectedRowIndex].columns[this.state.selectedColIndex].style?.justifyContent || 'flex-start'
                            }
                            onChange={(e) => this.handleModifyColumnStyle('justifyContent', e.target.value)}
                          >
                            <option value="flex-start">Inicio</option>
                            <option value="center">Centro</option>
                            <option value="flex-end">Final</option>
                            <option value="space-between">Espacio entre</option>
                            <option value="space-around">Espacio alrededor</option>
                          </select>
                          <label>Align Items:</label>
                          <select
                            value={
                              this.state.contentMap[this.state.selectedContentIndex].rows[this.state.selectedRowIndex].columns[this.state.selectedColIndex].style?.alignItems || 'stretch'
                            }
                            onChange={(e) => this.handleModifyColumnStyle('alignItems', e.target.value)}
                          >
                            <option value="stretch">Estirar</option>
                            <option value="flex-start">Inicio</option>
                            <option value="center">Centro</option>
                            <option value="flex-end">Final</option>
                          </select>
                          <label>Alineación del texto:</label>
                          <select
                            value={
                              this.state.contentMap[this.state.selectedContentIndex].rows[this.state.selectedRowIndex].columns[this.state.selectedColIndex].style?.textAlign || 'left'
                            }
                            onChange={(e) => this.handleModifyColumnStyle('textAlign', e.target.value)}
                          >
                            <option value="left">Izquierda</option>
                            <option value="center">Centro</option>
                            <option value="right">Derecha</option>
                            <option value="justify">Justificado</option>
                          </select>
                          <br />
                          <label>Color de fondo:</label>
                          <input
                            type="color"
                            value={
                              this.state.contentMap[this.state.selectedContentIndex].rows[this.state.selectedRowIndex].columns[this.state.selectedColIndex].style?.background || '#ffffff'
                            }
                            onChange={(e) => this.handleModifyColumnStyle('background', e.target.value)}
                          />

                          <div style={{ marginTop: '10px' }}>
                            <button onClick={() => this.handleModifyColumnStyle('background', 'transparent')}>
                              Fondo Transparente
                            </button>

                            <button
                              onClick={() =>
                                this.handleModifyColumnStyle('background', 'linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)')
                              }
                              style={{ marginLeft: '10px' }}
                            >
                              Fondo Degradado
                            </button>
                          </div>
                        </Col>
                      )}
                  </Row>
                  <div>
                    <button onClick={this.handleDeleteElement} style={{ backgroundColor: 'red', color: 'white' }}>
                      Eliminar elemento
                    </button>
                  </div>

                  <button onClick={() => this.setState({ isFooterVisible: false })}>Cerrar</button>
                </div>
              ) : (
                <div>
                  <h5>Selecciona un elemento para editar</h5>
                  <button onClick={() => this.setState({ isFooterVisible: false })}>Cerrar</button>
                </div>
              )}
            </footer>
          )}
        </div >
        <Form.Control
          style={{ display: 'none' }}
          id='itemImg'
          type='file'
          accept='image/png,image/jpeg,image/jpg'
          onChange={(e) => this.handleTitleImg(e)}
        />
        <Modal show={this.state.showContentModal} onHide={() => this.setState({ showContentModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Editar {this.state.currentEditType}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {this.state.currentEditType === 'Texto' && (
                <Form.Group>
                  <Form.Label>Texto</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={this.state.tempContentData}
                    onChange={(e) => this.setState({ tempContentData: e.target.value })}
                  />
                </Form.Group>
              )}
              {this.state.currentEditType === 'Lista' && (
                <Form.Group>
                  <Form.Label>Elementos de la lista (uno por línea)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={this.state.tempContentData}
                    onChange={(e) => this.setState({ tempContentData: e.target.value })}
                  />
                </Form.Group>
              )}
              {(this.state.currentEditType === 'Imagen' || this.state.currentEditType === 'Video') && (
                <>
                  <Form.Group>
                    <Form.Label>Buscar {this.state.currentEditType} en Pexels</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder={`Buscar ${this.state.currentEditType.toLowerCase()}...`}
                        value={this.state.searchQuery}
                        onChange={(e) => this.setState({ searchQuery: e.target.value })}
                      />
                      <Button variant="outline-primary" onClick={this.handleSearchPexels}>
                        Buscar
                      </Button>
                    </InputGroup>
                  </Form.Group>

                  <div className="mt-3" style={{ maxHeight: '250px', overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {this.state.searchResults.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => this.handleSelectPexelsItem(item)}
                        style={{ cursor: 'pointer', border: '2px solid #ddd', padding: '4px', borderRadius: '6px' }}
                      >
                        {this.state.currentEditType === 'Imagen' ? (
                          <img src={item.src} alt={item.alt} style={{ width: '100px' }} />
                        ) : (
                          <video src={item.src} style={{ width: '100px' }} muted />
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {this.state.currentEditType === 'Separador' && (
                <>
                  <Form.Group>
                    <Form.Label>Color</Form.Label>
                    <Form.Control
                      type="color"
                      value={this.state.tempContentData?.color || '#999999'}
                      onChange={(e) =>
                        this.setState({
                          tempContentData: {
                            ...this.state.tempContentData,
                            color: e.target.value,
                          },
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Tipo de línea</Form.Label>
                    <Form.Select
                      value={this.state.tempContentData?.borderStyle || 'dashed'}
                      onChange={(e) =>
                        this.setState({
                          tempContentData: {
                            ...this.state.tempContentData,
                            borderStyle: e.target.value,
                          },
                        })
                      }
                    >
                      <option value="solid">Sólida</option>
                      <option value="dashed">Discontinua</option>
                      <option value="dotted">Punteada</option>
                    </Form.Select>
                  </Form.Group>
                </>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showContentModal: false })}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={this.handleSaveContentRow}>
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
        {this.state.isFooterVisible && (
          <button
            onClick={() => this.setState({ isFooterVisible: false })}
            style={{
              position: 'fixed',
              top: 10,
              right: 10,
              background: 'transparent',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        )}
      </>
    );
  }
}
